(() => {
  const initModernProduct = (productInfo) => {
    if (!productInfo || productInfo.dataset.modernProductInitialized === 'true') return;

    const mobileBar = productInfo.querySelector('[data-modern-mobile-bar]');
    const mainButton = productInfo.querySelector('.product-form__submit');
    const mobileButton = productInfo.querySelector('[data-modern-mobile-submit]');
    const mobileLabel = productInfo.querySelector('[data-modern-mobile-label]');
    const mobilePrice = productInfo.querySelector('[data-modern-mobile-price]');
    const priceSource = productInfo.querySelector('[id^="price-"]');

    if (!mobileBar || !mainButton || !mobileButton) return;

    productInfo.dataset.modernProductInitialized = 'true';

    const syncPurchaseState = () => {
      const mainLabel = mainButton.querySelector('span');
      const currentPrice =
        priceSource?.querySelector('.price-item--last') ||
        priceSource?.querySelector('.price-item--regular');
      const isDisabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';

      mobileButton.disabled = isDisabled;

      if (mainLabel && mobileLabel) {
        mobileLabel.textContent = mainLabel.textContent.trim();
      }

      if (currentPrice && mobilePrice) {
        mobilePrice.textContent = currentPrice.textContent.trim();
      }
    };

    mobileButton.addEventListener('click', () => {
      syncPurchaseState();
      if (!mobileButton.disabled) mainButton.click();
    });

    productInfo.addEventListener('change', () => requestAnimationFrame(syncPurchaseState));

    const stateObserver = new MutationObserver(syncPurchaseState);
    stateObserver.observe(mainButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
    });

    if (priceSource) {
      stateObserver.observe(priceSource, { childList: true, subtree: true });
    }

    const visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        const productHasStarted = window.scrollY > productInfo.offsetTop + 120;
        mobileBar.classList.toggle('is-visible', !entry.isIntersecting && productHasStarted);
      },
      { threshold: 0.1 }
    );

    visibilityObserver.observe(mainButton);
    syncPurchaseState();
  };

  const initAllModernProducts = (scope = document) => {
    scope.querySelectorAll('product-info.modern-product').forEach(initModernProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllModernProducts());
  } else {
    initAllModernProducts();
  }

  document.addEventListener('shopify:section:load', (event) => initAllModernProducts(event.target));
  document.addEventListener('product-info:loaded', (event) => initModernProduct(event.target));
})();
